
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EnhancedUserList } from './EnhancedUserList';
import { Profile } from '@/types/database.types';

interface UserTabsProps {
  users: Profile[];
  filteredUsers: Profile[];
  recentUsers: Profile[];
  adminUsers: string[];
  onAdminStatusChange: () => void;
  getInitials: (firstName?: string | null, lastName?: string | null) => string;
  formatDate: (date: string) => string;
  onUserUpdated: () => void;
}

export const UserTabs = ({ 
  users, 
  filteredUsers, 
  recentUsers, 
  adminUsers, 
  onAdminStatusChange, 
  getInitials, 
  formatDate,
  onUserUpdated
}: UserTabsProps) => {
  return (
    <Tabs defaultValue="all" className="w-full">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="all">All Users ({users.length})</TabsTrigger>
        <TabsTrigger value="recent">Recent ({recentUsers.length})</TabsTrigger>
        <TabsTrigger value="admins">Admins ({adminUsers.length})</TabsTrigger>
      </TabsList>
      
      <TabsContent value="all" className="space-y-4">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <EnhancedUserList
            users={filteredUsers}
            adminUsers={adminUsers}
            getInitials={getInitials}
            formatDate={formatDate}
            onAdminStatusChange={onAdminStatusChange}
            onUserUpdated={onUserUpdated}
          />
        </div>
      </TabsContent>
      
      <TabsContent value="recent" className="space-y-4">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <EnhancedUserList
            users={recentUsers}
            adminUsers={adminUsers}
            getInitials={getInitials}
            formatDate={formatDate}
            onAdminStatusChange={onAdminStatusChange}
            onUserUpdated={onUserUpdated}
          />
        </div>
      </TabsContent>
      
      <TabsContent value="admins" className="space-y-4">
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <EnhancedUserList
            users={users.filter(user => adminUsers.includes(user.id))}
            adminUsers={adminUsers}
            getInitials={getInitials}
            formatDate={formatDate}
            onAdminStatusChange={onAdminStatusChange}
            onUserUpdated={onUserUpdated}
          />
        </div>
      </TabsContent>
    </Tabs>
  );
};
